import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { BusinessProvider } from "./context/BusinessContext";
// import Login from "./components/Login";
import Login from "./components/Login";
import Register from "./components/Register";
import Dashboard from "./components/Dashboard";
import Otp from "./components/Otp";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AuthPage from "./components/AuthPage";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import EmployeeRegister from "./components/EmployeeRegister";
import EmployeeLogin from "./components/EmployeeLogin";
import ForgotPasswordEmp from "./components/ForgotPasswordEmp";
import ResetEmpPassword from "./components/ResetEmpPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import BreakevenPage from "./components/BreakevenPage";
import LaborSchedulePlanner from "./components/LaborSchedulePlanner";
import HospitalityPage from "./components/HospitalityPage";


/* Hiric Theme Pages */
import Index1 from "./pages/Index1/Index1";
import Index2 from "./pages/Index2/Index2";
//import LandingPage from "./components/LandingPage";
import Index3 from "./pages/Index3/Index3";
import Index4 from "./pages/Index4/Index4";
import Index5 from "./pages/Index5/Index5";
import Index6 from "./pages/Index6/Index6";
import Index7 from "./pages/Index7/Index7";
import Index8 from "./pages/Index8/Index8";
import Index9 from "./pages/Index9/Index9";

/* Hiric Theme Auth Pages */

import SignUp from "./pages/Auth/signup";
import PasswordForget from "./pages/Auth/ForgotPassword";
import SetPassword from "./components/SetPassword";
import EmployeeDashboard from "./components/EmployeeDashboard";
import EmpOtp from "./components/EmpOtp";
import BusinessLogin from "./components/BusinessLogin";
import BusinessOtp from "./components/BusinessOtp";
import BusinessDashboard from "./components/BusinessDashboard";
import HospitalityAuditsPage from "./components/HospitalityAuditsPage";
import SeahausAuditsPage
  from "./components/SeahausAuditsPage";




function App() {

    
    return (
        <Router>

        

            <Routes>
                {/* Public Routes */}

                <Route path="/authpage" element={<AuthPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/emp-register" element={<EmployeeRegister />} />
                <Route path="/emp-login" element={<EmployeeLogin  />} />
                <Route path="/otp" element={<Otp />} />
                <Route path="/emp-otp" element={<EmpOtp />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/forgotpasswordemp" element={<ForgotPasswordEmp />} />
                <Route path="/resetpassword" element={<ResetPassword />} />
                <Route path="/resetemppassword" element={<ResetEmpPassword />} />
                <Route path="/set-password" element={<SetPassword />} />
                <Route path="/emp-dashboard/*" element={<EmployeeDashboard />} />
                <Route path="/bus-login/*" element={<BusinessLogin />} />
                <Route path="/business-otp/*" element={<BusinessOtp />} />
                <Route path="/bus-dashboard/*" element={<BusinessDashboard />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/breakeven" element={<BreakevenPage />} />
                <Route path="/labor-schedule-planner" element={<LaborSchedulePlanner />} />
                <Route
  path="/hospitality/*"
  element={<HospitalityPage />}
/>
<Route
  path="/hospitality/audits/:locationId"
  element={<HospitalityAuditsPage />}
/>
<Route
  path="/hospitality/seahaus/audits/:locationId"
  element={<SeahausAuditsPage />}
/>




                {/* Dashboard Route */}
                <Route
                    path="/dashboard/*"
                    element={
                        <BusinessProvider>
                            <Dashboard />
                        </BusinessProvider>
                    }
                />



                {/* Hiric Theme Auth Routes */}
                <Route path="/signup" element={<SignUp />} />
                
                <Route path="/password_forget" element={<PasswordForget />} />

                {/* Hiric Theme Pages */}
                <Route path="/index9" element={<Index9 />} />
                <Route path="/index8" element={<Index8 />} />
                <Route path="/index7" element={<Index7 />} />
                <Route path="/index6" element={<Index6 />} />
                <Route path="/index5" element={<Index5 />} />
                <Route path="/index4" element={<Index4 />} />
                <Route path="/home" element={<Index3 />} />
                <Route path="/index2" element={<Index2 />} />
                <Route path="/index1" element={<Index1 />} />

                {/* Default Route */}
                <Route path="/" element={<Navigate to="/home" />} />
            </Routes>

    
        </Router>
    );
}

export default App;





// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { BusinessProvider } from "./context/BusinessContext";
// import Register from "./components/Register";
// import Login from "./components/Login";
// import Dashboard from "./components/Dashboard";
// import AddBusiness from "./components/AddBusiness";
// import BusinessPage from "./components/BusinessPage";
// import AddEmployeePage from "./components/AddEmployeePage";
// import EditEmployeePage from "./components/EditEmployeePage";
// import EmployeesPage from "./components/EmployeesPage";
// import StartPayrollPage from "./components/StartPayrollPage";
// import AddPreviousPayrollPage from "./components/AddPreviousPayrollPage";
// import Otp from "./components/Otp";
// import ForgotPassword from './components/ForgotPassword';
// import ResetPassword from './components/ResetPassword';

// function App() {
//     return (
//         <Router>
//             <Routes>
//                 {/* Public Routes */}
//                 <Route path="/" element={<Navigate to="/login" />} />
//                 <Route path="/register" element={<Register />} />
//                 <Route path="/login" element={<Login />} />
//                 <Route path="/otp" element={<Otp />} />
//                 <Route path="/forgotpassword" element={<ForgotPassword />} />
//                 <Route path="/resetpassword" element={<ResetPassword />} />

//                 {/* Dashboard Routes */}
//                 <Route
//                     path="/dashboard/*"
//                     element={
//                         <BusinessProvider>
//                             <Dashboard />
//                         </BusinessProvider>
//                     }
//                 >
//                     {/* Nested Routes under Dashboard */}
//                     <Route path="add-business" element={<AddBusiness />} />
//                     <Route path="business/:id" element={<BusinessPage />} />
//                     <Route path="business/:id/add-employee" element={<AddEmployeePage />} />
//                     <Route path="business/:id/edit-employee/:employeeId" element={<EditEmployeePage />} />
//                     <Route path="business/:id/employees" element={<EmployeesPage />} />
//                     <Route path="business/:id/start-payroll" element={<StartPayrollPage />} />
//                     <Route path="business/:id/add-previous-payroll" element={<AddPreviousPayrollPage />} />
//                 </Route>
//             </Routes>
//         </Router>
//     );
// }

// export default App;

// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { BusinessProvider } from "./context/BusinessContext";
// import Register from "./components/Register";
// import Login from "./components/Login";
// import Dashboard from "./components/Dashboard";
// import AddBusiness from "./components/AddBusiness";
// import BusinessPage from "./components/BusinessPage";
// import AddEmployeePage from "./components/AddEmployeePage";
// import EditEmployeePage from "./components/EditEmployeePage";
// import EmployeesPage from "./components/EmployeesPage";
// import StartPayrollPage from "./components/StartPayrollPage";
// import AddPreviousPayrollPage from "./components/AddPreviousPayrollPage";
// import Otp from "./components/Otp";
// import ForgotPassword from './components/ForgotPassword';
// import ResetPassword from './components/ResetPassword';

// function App() {
//     return (
//         <Router>
//             <Routes>
//                 {/* Public Routes */}
//                 <Route path="/" element={<Navigate to="/login" />} />
//                 <Route path="/register" element={<Register />} />
//                 <Route path="/login" element={<Login />} />
//                 <Route path="/otp" element={<Otp />} />
//                 <Route path="/forgotpassword" element={<ForgotPassword />} />
//                 <Route path="/resetpassword" element={<ResetPassword />} />

//                 {/* Dashboard Routes */}
//                 <Route
//                     path="/dashboard/*"
//                     element={
//                         <BusinessProvider>
//                             <Dashboard />
//                         </BusinessProvider>
//                     }
//                 >
//                     {/* Nested Routes under Dashboard */}
//                     <Route path="add-business" element={<AddBusiness />} />
//                     <Route path="business/:id" element={<BusinessPage />} />
//                     <Route path="business/:id/add-employee" element={<AddEmployeePage />} />
//                     <Route path="business/:id/edit-employee/:employeeId" element={<EditEmployeePage />} />
//                     <Route path="business/:id/employees" element={<EmployeesPage />} />
//                     <Route path="business/:id/start-payroll" element={<StartPayrollPage />} />
//                     <Route path="business/:id/add-previous-payroll" element={<AddPreviousPayrollPage />} />
//                 </Route>
//             </Routes>
//         </Router>
//     );
// }

// export default App;

// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Register from "./components/Register";
// import Login from "./components/Login";
// import Dashboard from "./components/Dashboard";
// import AddBusiness from "./components/AddBusiness";
// import BusinessPage from "./components/BusinessPage";
// import Otp from "./components/Otp";
// import ForgotPassword from './components/ForgotPassword';
// import ResetPassword from './components/ResetPassword';
// import AddEmployeePage from "./components/AddEmployeePage";
// import EditEmployeePage from "./components/EditEmployeePage";
// import EmployeesPage from "./components/EmployeesPage";
// import StartPayrollPage from "./components/StartPayrollPage";
// import AddPreviousPayrollPage from "./components/AddPreviousPayrollPage";

// function App() {
//     return (
//         <Router>
//             <Routes>
//                 {/* Public Routes */}
//                 <Route path="/" element={<Navigate to="/login" />} />
//                 <Route path="/register" element={<Register />} />
//                 <Route path="/login" element={<Login />} />
//                 <Route path="/otp" element={<Otp />} />
//                 <Route path="/forgotpassword" element={<ForgotPassword />} />
//                 <Route path="/resetpassword" element={<ResetPassword />} />

//                 {/* Dashboard Routes */}
//                 <Route path="/dashboard/*" element={ <BusinessProvider><Dashboard /> } />
//                     <Route path="add-business" element={<AddBusiness />} />
//                     <Route path="business/:id" element={<BusinessPage />} />
//                     <Route path="business/:id/add-employee" element={<AddEmployeePage />} />
//                     <Route path="business/:id/edit-employee/:employeeId" element={<EditEmployeePage />} />
//                     <Route path="business/:id/employees" element={<EmployeesPage />} />
//                     <Route path="business/:id/start-payroll" element={<StartPayrollPage />} />
//                     <Route path="business/:id/add-previous-payroll" element={<AddPreviousPayrollPage />} />
//                     </BusinessProvider>
                    
//                      {/* Add other nested routes for dashboard here */}
//                 />
//             </Routes>
//         </Router>
//     );
// }

// export default App;






// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Register from "./components/Register";
// import Login from "./components/Login";
// import Otp from "./components/Otp";
// import Dashboard from "./components/Dashboard";
// import AddBusiness from "./components/Addbusiness";
// import ForgotPassword from './components/ForgotPassword';
// import ResetPassword from './components/ResetPassword';
// import BusinessPage from "./components/BusinessPage";
// import AddEmployeePage from "./components/AddEmployeePage";
// import EditEmployeePage from "./components/EditEmployeePage";
// import EmployeesPage from "./components/EmployeesPage";
// import StartPayrollPage from "./components/StartPayrollPage";
// import AddPreviousPayrollPage from "./components/AddPreviousPayrollPage";


// function App() {
//     return (
//         <Router>
//             <Routes>
//                 {/* Default route to redirect to Login */}
//                 <Route path="/" element={<Navigate to="/login" />} />

//                 {/* Other routes */}
//                 <Route path="/register" element={<Register />} />
//                 <Route path="/login" element={<Login />} />
//                 <Route path="/otp" element={<Otp />} />
//                 <Route path="/dashboard" element={<Dashboard />} />
//                 <Route path="/add-business" element={<AddBusiness />} />
//                 <Route path="/forgotpassword" element={<ForgotPassword />} />
//                 <Route path="/resetpassword" element={<ResetPassword />} />
//                 <Route path="/businesses/:id" element={<BusinessPage />} />
//                 <Route path="/business/:id/add-employee" element={<AddEmployeePage />} />
//                 <Route path="/business/:id/edit-employee/:employeeId" element={<EditEmployeePage />} />
//                 <Route path="/business/:id/employees" element={<EmployeesPage />} />
//                 <Route path="/business/:id/start-payroll" element={<StartPayrollPage />} />
//                 <Route path="/business/:id/add-previous-payroll" element={<AddPreviousPayrollPage />} />


//             </Routes>
//         </Router>
//     );
// }

// export default App;
